<template>
    <div class="main_bd">
        <div class="head_title">Crepe Game Management</div>
        <div class="head_title" style="margin-bottom: 10px; text-align: right;">
            <a-button :loading="export_loading" :disabled="export_loading" type="primary" @click="export_crepe_records">Export All</a-button>
        </div>
        <div class="mod_default_box permission">
            <a-table :pagination="false" :rowKey="data => data.id" :columns="columns" :data-source="crepe_records" >
                <div slot="game_info" slot-scope="text, data">
                    <div>Game 1: {{ data.answer_1_text + ' / ' + data.answer_1 }}</div>
                    <div>Game 2: {{ data.answer_2_text + ' / ' + data.answer_2 }}</div>
                    <div>Game 3: {{ data.answer_3_text + ' / ' + data.answer_3 }}</div>
                    <div>Game 4: {{ data.answer_4_text + ' / ' + data.answer_4 }}</div>
                </div>
                <div slot="result_info" slot-scope="text, data">
                    <div>Result Code: {{ data.result_code }}</div>
                    <div>Crepe Name: {{ data.crepe_name }}</div>
                    <div>Crepe Personality: {{ data.crepe_personality }}</div>
                    <div>Crepe Description: {{ data.crepe_description }}</div>
                </div>
                <div slot="action" slot-scope="text, data">
                    <a-button type="danger" @click="del_crepe_record(data.id)">Delete</a-button>
                </div>
            </a-table>
            <a-pagination style="margin-top: 5px;" @change="turnPage" :pageSize="20" v-model="cur_page" :total="total_count"
                show-less-items />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);

    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    const columns = [
        {
            title: "#",
            dataIndex: "index",
        },
        {
            title: "Phone",
            dataIndex: "phone_num",
        },
        {
            title: "Email",
            dataIndex: "email",
        },
        {
            title: "Coupon Name",
            dataIndex: "coupon_name",
        },
        {
            title: "Game Info",
            scopedSlots: { customRender: 'game_info' },
        },
        {
            title: "Result Info",
            scopedSlots: { customRender: 'result_info' },
        },
        {
            title: "Create time",
            dataIndex: "create_time",
            width: 150
        },
        {
            title: "Action",
            scopedSlots: { customRender: 'action' },
        }
    ];

    export default {
        name: 'crepe_records_list',
        components: {
        },
        data() {
            return {
                sid: window.localStorage.getItem('sid'),
                columns,
                cur_page: 1,
                total_page: 0,
                total_count: 0,
                crepe_records: [],
                export_loading: false,
            };
        },
        beforeMount() {
            let _sid = window.localStorage.getItem('sid') || '';
            let _token = window.localStorage.getItem('token') || '';

            if (!_sid || !_token) {
                window.location.replace('/login');
            }
        },
        async created() {
            this.get_crepe_records();
        },
        watch: {
        },
        mounted() {

        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({})
        },
        methods: {
            ...mapActions({
                getCrepeRecords: 'games/getCrepeRecords',
                delCrepeRecord: 'games/delCrepeRecord',
                exportCrepeRecords: 'games/exportCrepeRecords',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            async get_crepe_records() {
                let { list, total_count, total_page } = await this.getCrepeRecords({
                    page: this.cur_page,
                    page_size: 20,
                });

                this.crepe_records = list;
                this.total_page = total_page;
                this.total_count = total_count;
            },
            turnPage(e) {
                this.get_crepe_records();
            },
            async del_crepe_record(id) {
                let _this = this;
                this.$confirm({
                    title: 'Are you sure you want to delete this record?',
                    content: 'Unable to recover after deletion',
                    okText: 'Yes, delete it!',
                    okType: 'danger',
                    cancelText: 'No, cancel',
                    onOk: async () => {
                        let res = await _this.delCrepeRecord({ id: id });
                        if (res.code == 100000) {
                            _this.$message.success('Delete record success');
                            _this.get_crepe_records();
                        } else {
                            _this.$message.error(res.msg || 'Delete record failed');
                        }
                    },
                    onCancel: () => {},
                });
            },
            async export_crepe_records() {
                this.export_loading = true;
                let res = await this.exportCrepeRecords();

                let uploadExcel = function(fileName) {
                    let blob = new Blob([res], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                    });
                    let url = URL.createObjectURL(blob);
                    let aLink = document.createElement("a");
                    aLink.setAttribute("download", fileName);
                    aLink.setAttribute("href", url);
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink);
                    URL.revokeObjectURL(url);
                };

                uploadExcel("crepe_records_" + new Date().getTime() + ".xlsx");
                this.export_loading = false;
            }
        }
    };
</script>

<style>
</style>